import type { CategorisedResponse, FullActivityItem } from '@customTypes/types';
import { Flex } from '@mantine/core';

import { BoardCol } from '../board-col/BoardCol';
import { TaskCard } from '../task-card/TaskCard';

export const Board = ({
  data,
  onSelectItem
}: {
  data: CategorisedResponse;
  onSelectItem: (activityItem: FullActivityItem) => void;
}) => (
  <Flex gap={20} wrap='nowrap'>
    {data &&
      Object.entries(data).map(([key, value]) => (
        <BoardCol
          key={key}
          colTitle={key}
          data={value}
          renderItem={TaskCard}
          onSelectItem={onSelectItem}
        />
      ))}
  </Flex>
);
